export default __webpack_public_path__ + "static/media/MilkyWay.e5f7320a.png";